import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Vermont Tier2 Submit": {
    parameters: {
      linkUrls: ["https://vtdfs.powerappsportals.us/tier-ii/"],
      staffInputs: {
        documentTypes: {
          report: false,
          submission: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Tier2 Submit",
    state: "VT",
  },
};
